import { ColDef, SortDirection } from 'ag-grid-community';
import { ExternalFilterColDef } from './filter/list-view-external-filtering.model';

export enum ExternalFilterType {
  Checkbox = 'checkbox',
  Range = 'range',
}

export interface ListViewColDef<TData = unknown> extends ColDef<TData> {
  externalSortingOrder?: Array<{
    sort: SortDirection;
    label: string;
    initial?: boolean;
  }>;

  externalFilter?: ExternalFilterColDef<TData>;
}
